// extracted by mini-css-extract-plugin
export default {"GoogleSignIn":"GoogleSignIn_GoogleSignIn__ms-6O"};